const allData = document.querySelector('[id^="quiz-data-"]')

const quizData = JSON.parse(allData.textContent)

console.log(quizData);

const el = {
    progressBar: document.querySelector('[data-progress-bar]'),
    resultStep: document.querySelector('[data-step="result"]'),
    resultIntro: document.querySelector('[data-result-intro]'),
    recommendedProducts: document.querySelector('[data-recommended-products]'),
    bundleStack: document.querySelector('[data-bundle-stack]'),
    bundleName: document.querySelector('[data-bundle-name]'),
    bundleDescription: document.querySelector('[data-bundle-description]'),
    bundlePriceNow: document.querySelector('[data-bundle-price-now]'),
    bundlePriceWas: document.querySelector('[data-bundle-price-was]'),
    bundlePriceSave: document.querySelector('[data-bundle-price-save]'),
    pathDirect: document.querySelector('[data-path-direct]'),
    pathEmail: document.querySelector ('[data-path-email]'),
    emailInput: document.querySelector ('[data-email-input]'),
    emailError: document.querySelector ('[data-email-error]'),
    emailToast: document.querySelector ('[data-email-toast]'),
    reset: document.querySelector ('[data-reset]'),

};

console.log(el);

const state = {
    currentIndex: 0,
    answers: {},
    recommendedProducts: [],
};

const questionSteps = document.querySelectorAll ('[data-step="question"]');
console.log(questionSteps)

questionSteps.forEach((step) => {
    const key =step.dataset.questionKey;
    state.answers[key] = [];
})

console.log(state)



